import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

const loadLocaleMessages = () => {
  const locales = require.context('@/', true, /i18n_.*.json/)
  const messages = {}
  locales.keys().forEach((key) => {
    const locale = key.match(/i18n_(.*).json/i)[1]
    messages[locale] = messages[locale] ? { ...messages[locale], ...locales(key) } : locales(key)
  })

  return messages
}

const i18n = new VueI18n({
  locale: 'pt-BR',
  fallbackLocale: 'pt-BR',
  silentFallbackWarn: true,
  messages: loadLocaleMessages(),
})

export default i18n
